export default "__VITE_ASSET__BHMkgrVe__"